import { useState } from "react";
import { Link, useLocation } from "react-router-dom";
import { useAuth } from "@/auth/AuthContext.jsx";
import { useCart } from "@/cart/CartContext.jsx";
import Icon from "@/components/icons/Icon.jsx";
import LoginModal from "@/components/LoginModal.jsx";
import { CART_ROUTE, ROLES } from "@/utils/constants.js";
import { isStaffRole } from "@/utils/staffAccess.js";
import { isMobileCartFabRoute } from "@/utils/mobileCartFab.js";
import "./mobile-cart-fab.css";

/**
 * Fixed phone/tablet cart shortcut (bottom-center). Guests open login; customers go to the cart.
 */
export default function MobileCartFab() {
    const location = useLocation();
    const { isAuthenticated, role } = useAuth();
    const { itemCount } = useCart();
    const [showLogin, setShowLogin] = useState(false);

    const onRoute = isMobileCartFabRoute(location.pathname, location.search);
    const isAdmin = isAuthenticated && isStaffRole(role);
    const isCustomer = isAuthenticated && role === ROLES.CUSTOMER;

    if (!onRoute || isAdmin) {
        return null;
    }

    const hasItems = isCustomer && itemCount > 0;
    const label = hasItems ? String(itemCount) : "Panier";
    const ariaLabel = hasItems
        ? `Panier, ${itemCount} article${itemCount > 1 ? "s" : ""}`
        : "Panier";

    const content = (
        <>
            <Icon name="cart" className="mobile-cart-fab__icon" color="#ffffff" />
            <span className="mobile-cart-fab__label">{label}</span>
        </>
    );

    return (
        <>
            {isCustomer ? (
                <Link
                    to={CART_ROUTE}
                    className="mobile-cart-fab"
                    aria-label={ariaLabel}
                    data-tour="mobile-cart-fab"
                >
                    {content}
                </Link>
            ) : (
                <button
                    type="button"
                    className="mobile-cart-fab"
                    aria-label={ariaLabel}
                    data-tour="mobile-cart-fab"
                    onClick={() => setShowLogin(true)}
                >
                    {content}
                </button>
            )}
            {showLogin && (
                <LoginModal
                    initialMode="login"
                    returnTo={CART_ROUTE}
                    onClose={() => setShowLogin(false)}
                />
            )}
        </>
    );
}
